<template>
    <div class="main_apply main_container">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="重新提交申请" name="first">
            <el-form :model="dataInfo"  ref="dataInfo" :rules="rulesData" label-width="150px" class="demo-ruleForm myForm" style="width: 70%; margin: auto;">
                <div class="item_box">
                   <div class="title_sty">申请人基本信息</div>

                    <div class="inpitem_box">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterName.CheckStatus==0?'showIcon':'hideIcon'" style="left:30px;">
                        <el-form-item label="申请人姓名:" prop="RequesterName.NodeValue" >
                            <el-input v-model="dataInfo.RequesterName.NodeValue" class="inpItem" :disabled="dataInfo.RequesterName.disabled"></el-input>
                        </el-form-item>
                    </div>
                    <div class="inpitem_box">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterPhoneNum.CheckStatus==0?'showIcon':'hideIcon'" style="left:30px;">
                        <el-form-item label="申请人电话:" prop="RequesterPhoneNum.NodeValue" >
                            <el-input v-model="dataInfo.RequesterPhoneNum.NodeValue" :disabled='disabled'></el-input>
                        </el-form-item>
                    </div>
                    <div class="inpitem_box" v-if="commitType == 2">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterOrganisation.CheckStatus==0?'showIcon':'hideIcon'" style="left:44px;" >
                        <el-form-item label="所在单位:" prop="RequesterOrganisation.NodeValue" >
                            <el-input v-model="dataInfo.RequesterOrganisation.NodeValue" :disabled="dataInfo.RequesterOrganisation.disabled"></el-input>
                        </el-form-item>
                    </div>
                    <div class="inpitem_box" v-if="commitType == 2" >
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.PersonIdentification.CheckStatus==0?'showIcon':'hideIcon'" style="left:15px;">
                        <el-form-item label="个人身份证明:" prop="PersonIdentification.NodeValue">
                            <div v-if="dataInfo.PersonIdentification.CheckStatus!=0">
                                <div v-for="item in dataInfo.PersonIdentification.NodeValue" :key="item.FileGuid" class="input_box" >
                                    <!-- <el-input v-model="item.FileName" class="input_fileName"  disabled="disabled" style="background:#fff;"></el-input> -->
                                    <div :id="'indexImg_'+item.FileGuid" :ref="'indexImg_'+item.FileGuid" style="margin-top: 10px;">
                                        <ul style="display:inline-block;">
                                            <li style="display:inline-block;" >
                                                <span  class="input_fileName" style="display:inline-block;color:#606266;">
                                                    {{item.FileName}}
                                                </span>
                                                <a class="view_a" target="_blank" id="test" @click="showImgFn(item.FileGuid)">
                                                    查看
                                                    <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid">
                                                </a>
                                            </li>
                                        </ul>
                                        <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid" download="个人身份证明" title="下载"  target="_blank" class="download_a">
                                            下载
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div v-if="dataInfo.PersonIdentification.CheckStatus==0">
                                <div v-for="item in dataInfo.PersonIdentification.NodeValue" :key="item.FileGuid" class="input_box" >
                                    <!-- <el-input v-model="item.FileName" class="input_fileName" v-if="ifFileNmae0" disabled="disabled" style="background:#fff;"></el-input> -->
                                    <div :id="'indexImg_'+item.FileGuid" :ref="'indexImg_'+item.FileGuid" v-if="ifFileNmae0" style="margin-top: 10px;">
                                        <ul style="display:inline-block;">
                                            <li style="display:inline-block;" >
                                                <span  class="input_fileName" v-if="ifFileNmae0" style="display:inline-block;color:#606266;">
                                                    {{item.FileName}}
                                                </span>
                                                <a class="view_a" target="_blank" id="test" @click="showImgFn(item.FileGuid)">
                                                    查看
                                                    <img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid">
                                                </a>
                                            </li>
                                        </ul>
                                        <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid" download="个人身份证明" title="下载"  target="_blank" class="download_a">
                                            下载
                                        </a>
                                    </div>
                                </div>
                                <el-button size="small" type="primary" @click="uploadAuth(0)">点击上传</el-button>
                                <el-button  :data-img="url" type="text" size="small" @click="$imgPreview">模板</el-button>
                                <p class="tipText">个人身份证明为作者本人身份证扫描件、学生证扫描件或者教师证扫描件，支持gif、png、jpg格式<br>请一次性上传所有文件</p>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="item_box">
                    <div class="title_sty">待撤文章信息</div>
                    <div class="inpitem_box">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.ArticleName.CheckStatus==0?'showIcon':'hideIcon'" style="left:45px;">
                        <el-form-item label="题目名称:" prop="ArticleName.NodeValue"  >
                            <el-input v-model="dataInfo.ArticleName.NodeValue" :disabled="dataInfo.ArticleName.disabled"></el-input>
                            <!-- <div class="el-upload__tip">请输入待撤文章的题目名称</div> -->
                        </el-form-item>
                    </div>
                    <div class="inpitem_box">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.Author.CheckStatus==0?'showIcon':'hideIcon'" style="left:75px;">
                        <el-form-item label="作者:" prop="Author.NodeValue" >
                            <el-input v-model="dataInfo.Author.NodeValue" :disabled="dataInfo.Author.disabled"></el-input>
                        </el-form-item>
                    </div>
                    <div class="inpitem_box" v-if="commitType == 2">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.UnitIdentification.CheckStatus==0?'showIcon':'hideIcon'" style="left:-10px;">
                        <el-form-item label="单位允许撤除证明:" prop="UnitIdentification.NodeValue" >
                            <!-- <p>{{formData.UnitIdentification.FileName}}</p> -->
                            <div v-if="dataInfo.UnitIdentification.CheckStatus!=0">
                                <!-- <el-input v-model="dataInfo.UnitIdentification.NodeValue[0].FileName" class="input_fileName" disabled="disabled"></el-input> -->
                                <div :id="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid" >
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span  class="input_fileName"  style="display:inline-block;color:#606266;">{{dataInfo.UnitIdentification.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.UnitIdentification.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid" download="单位允许撤除证明" title="下载"  target="_blank" class="download_a">
                                        下载
                                    </a>
                                </div>
                            </div>
                            <div v-if="dataInfo.UnitIdentification.CheckStatus==0">
                                <!-- <el-input v-model="dataInfo.UnitIdentification.NodeValue[0].FileName" class="input_fileName" v-if="ifFileNmae1" disabled="disabled"></el-input> -->
                                <div :id="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid" v-if="ifFileNmae1">
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span  class="input_fileName"  style="display:inline-block;color:#606266;">{{dataInfo.UnitIdentification.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.UnitIdentification.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid" download="单位允许撤除证明" title="下载"  target="_blank" class="download_a">
                                        下载
                                    </a>
                                </div>
                                <el-button size="small" type="primary" @click="uploadAuth(1)">点击上传</el-button>
                                <span class="model_span" style="margin-left:10px;">
                                    <a :href="authImgUrl+'/api/Common/GetTemplateFile'" download="单位允许撤除证明模板" title="单位允许撤除证明模板"  target="_blank" class="download_a">
                                        模板
                                    </a>
                                </span>
                                <p class="tipText">证明必须加盖检测单位管理部门公章，支持gif、png、jpg格式</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="inpitem_box">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.CheckReport.CheckStatus==0?'showIcon':'hideIcon'" style="left:30px;">
                        <el-form-item label="检测报告单:" prop="CheckReport.NodeValue" required>
                            <!-- <p>{{formData.CheckReport.FileName}}</p> -->
                            <div v-if="dataInfo.CheckReport.CheckStatus!=0">
                                <!-- <el-input v-model="dataInfo.CheckReport.NodeValue[0].FileName" class="input_fileName" disabled="disabled"></el-input> -->
                                <div :id="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid" >
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span  class="input_fileName"  style="display:inline-block;color:#606266;">{{dataInfo.CheckReport.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.CheckReport.NodeValue[0].FileGuid,'pdf')">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                        下载
                                    </a>
                                </div>
                            </div>
                            <div v-if="dataInfo.CheckReport.CheckStatus==0">
                                <!-- <el-input v-model="dataInfo.CheckReport.NodeValue[0].FileName" class="input_fileName" v-if="ifFileNmae2" disabled="disabled"></el-input> -->
                               <div :id="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid" v-if="ifFileNmae2">
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span  class="input_fileName"  style="display:inline-block;color:#606266;">{{dataInfo.CheckReport.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.CheckReport.NodeValue[0].FileGuid,'pdf')">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                        下载
                                    </a>
                                </div>
                                <el-button size="small" type="primary" @click="uploadAuth(2)">点击上传</el-button>
                                <el-button  :data-img="url2" type="text" size="small" @click="$imgPreview">示例</el-button>
                                <p class="tipText">请提供最近一次检测报告单，并在报告单上标注要撤除的文献，支持pdf格式</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="inpitem_box">
                        <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.ArticleLocation.CheckStatus==0?'showIcon':'hideIcon'" style="left:20px;">
                        <el-form-item label="待撤文章位置:" prop="ArticleLocation.NodeValue" required>
                            <!-- <p>{{formData.ArticleLocation.FileName}}</p> -->
                            <div v-if="dataInfo.ArticleLocation.CheckStatus!=0">
                                <!-- <el-input v-model="dataInfo.ArticleLocation.NodeValue[0].FileName" class="input_fileName"  disabled="disabled"></el-input> -->
                                <div :id="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid" >
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span  class="input_fileName"  style="display:inline-block;color:#606266;">{{dataInfo.ArticleLocation.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.ArticleLocation.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                        下载
                                    </a>
                                </div>
                            </div>

                            <div v-if="dataInfo.ArticleLocation.CheckStatus==0">
                                <!-- <el-input v-model="dataInfo.ArticleLocation.NodeValue[0].FileName" class="input_fileName" v-if="ifFileNmae3" disabled="disabled"></el-input> -->
                                <div :id="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid"  v-if="ifFileNmae3">
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span  class="input_fileName"  style="display:inline-block;color:#606266;">{{dataInfo.ArticleLocation.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.ArticleLocation.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                        下载
                                    </a>
                                </div>
                                <el-button size="small" type="primary" @click="uploadAuth(3)">点击上传</el-button>
                                <el-button  :data-img="url2" type="text" size="small" @click="$imgPreview">示例</el-button>
                                <p class="tipText">请将待撤文章在检测报告单中的具体位置进行标注并上传标注后的附件，支持gif、png、jpg格式</p>
                            </div>


                        </el-form-item>
                    </div>
                </div>
                <div class="subBtn_box">
                    <el-form-item class="btn_box">
                        <el-button type="primary" @click="submitInfo('dataInfo')" class="submit_btn" v-loading="regLoading">确认提交</el-button>
                        <el-button  type="primary" class="submit_btn" @click="backViewPageFn">取消</el-button>
                    </el-form-item>
                </div>
            </el-form>
            <global-uploader></global-uploader>
        </el-tab-pane>

    </el-tabs>
    </div>
</template>
<script>
import Bus from '@/components/Upload/js/bus.js';
import globalUploader from '@/components/Upload/globalUploader.vue';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    data(){
        var validatePasswordAgin = (rule, value, callback) => {
            if(value==""){
                return callback(new Error('请输入确认密码'))
            }else if(value!==this.registParamsData.Password){
                return callback(new Error('两次密码输入不一致'))
            }else{
                callback();
            }
        }
        return{
            authImgUrl:BASE_URL,
            imgUrl:require("../../../assets/images/warn_icon1.png"),
            disabled:'disabled',
            ifSmallImg:false,
            url: require("../../../assets/images/identImg.png"),
            srcList: [
            require("../../../assets/images/identImg.png"),
            // 'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
            ],
            url2:require("../../../assets/images/model_img.png"),
            srcList2:[
                require("../../../assets/images/model_img.png"),
            ],
            ifFileNmae0:false,
            ifFileNmae1:false,
            ifFileNmae2:false,
            ifFileNmae3:false,
            //ifUpFileNmae3:false,
            activeName: 'first',
            rulesData: {
                'RequesterName.NodeValue':  { required: true, message: '请输入申请人姓名', trigger: 'blur' },
                "RequesterPhoneNum.NodeValue":{ required: true, message: '请输入申请人电话', trigger: 'blur' },
                "RequesterOrganisation.NodeValue":{ required: true, message: '请输入所在单位', trigger: 'blur' },
                "PersonIdentification.NodeValue":{required: true, message: '至少上传一个身份证明', trigger: 'blur'},
                "ArticleName.NodeValue":{ required: true, message: '请输入待撤除文章题目', trigger: 'blur' },
                "Author.NodeValue":{ required: true, message: '请输入作者', trigger: 'blur' },
                "UnitIdentification.NodeValue":{ required: true, message: '请上传单位允许撤除证明', trigger: 'blur' },
                "CheckReport.NodeValue":{required: true, message: '请上传检测报告单', trigger: 'blur' },
                "ArticleLocation.NodeValue":{required: true, message: '请上传待撤文章位置', trigger: 'blur' }
            },
            formData:{
                "CommitType": "",
                "RequestID":"",
                "RequesterName": "",
                "RequesterPhoneNum": sessionStorage.getItem("userName"),
                "RequesterOrganisation": "",
                "PersonIdentification": [],//0类型（身份证）
                "ArticleName": "",
                "Author": "",
                "Publication": "",
                "PublishTime": "",
                "UnitIdentification": [],//1类型上传
                "CheckReport": [], //2类型上传
                "ArticleLocation": [],//3类型上传
            },
            dataInfo:{
                RequesterName:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                RequesterPhoneNum:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                RequesterOrganisation:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                PersonIdentification:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                ArticleName:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                Author:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                Publication:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                PublishTime:{
                    NodeValue:"",
                    CheckStatus:"",
                    ID:""
                },
                UnitIdentification:{
                    NodeValue:[],
                    CheckStatus:"",
                    ID:""
                },
                CheckReport:{
                    NodeValue:[],
                    CheckStatus:"",
                    ID:""
                },
                ArticleLocation:{
                    NodeValue:[],
                    CheckStatus:"",
                    ID:""
                },
                CreateTime:"",
                ifShenHe:true,
                ifZhixing:false,
                ifReCommit:false,
                requestID:""
            },
            updataType:null,
            regLoading:false,
            paramsData:{
                requestID:"",
                Comment: "",
                UpdateTime: ""
            },
            commitType: ""

        }
    },
    components:{globalUploader},
    created(){
        if(this.$route.params){
            this.paramsData.requestID= this.$route.params.id;
            this.commitType = this.$route.params.type
            this.paramsData.Comment=this.$route.params.row.Comment
            this.paramsData.UpdateTime=this.$route.params.row.UpdateTime
        }
        this.detailGetBysearchParam(this.paramsData);
        //console.log("formData",this.formData);
    },
    mounted(){
        if(this.$route.params&&this.$route.params.formData){
            this.formData = this.$route.params.formData;
            this.ifFileNmae0=true
            this.ifFileNmae1=true
            this.ifFileNmae2=true
            this.ifFileNmae3=true
        }
        var _this = this;
        Bus.$on('fileadded', (loginToken) => {
            console.log('文件已选择');
        });

        // 文件上传成功的回调
        Bus.$on('filesuccess', query => {
            // console.log('文件上传成功',query.FileGuid)
            // console.log('文件上传成功',query)
            if(_this.updataType==0){
                _this.ifFileNmae0=true
                // if(_this.dataInfo.PersonIdentification.NodeValue.length==10){
                //     this.$message({
                //         message: "最多上传10个文件",
                //         type: 'error',
                //         duration: 5 * 1000
                //     })
                // }else{
                //     _this.dataInfo.PersonIdentification.NodeValue.push(query)
                // }

                _this.dataInfo.PersonIdentification.NodeValue.push(query)

            }else if(_this.updataType==1){
                _this.ifFileNmae1=true
                _this.dataInfo.UnitIdentification.NodeValue=[]
                _this.dataInfo.UnitIdentification.NodeValue.push(query);
            }else if(_this.updataType==2){
                _this.ifFileNmae2=true
                _this.dataInfo.CheckReport.NodeValue=[]
                _this.dataInfo.CheckReport.NodeValue.push(query);
            }else if(_this.updataType==3){
                _this.ifFileNmae3=true
                _this.dataInfo.ArticleLocation.NodeValue=[]
                _this.dataInfo.ArticleLocation.NodeValue.push(query);
            }
        });
    },
    methods:{
        showImgFn(FileGuid,Clicktype){
            if(Clicktype){
                var url = this.authImgUrl+'/api/Common/GetOriginalFile?BatchID='+FileGuid;
                window.open(location.origin+location.pathname+'static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
                return false;
            }
            var _this = this;
            // console.log("_this[FileGuid]=====",_this[FileGuid]);
            var ViewerDom = document.getElementById('indexImg_'+FileGuid);
            // console.log("ViewerDom===",ViewerDom)
            // debugger
            if(!_this[FileGuid]){
                _this[FileGuid] = new Viewer(document.getElementById('indexImg_'+FileGuid), {
                // 相关配置项,详情见下面
                inline: false,  //是否启用 inline 模式
                url: 'data-original',  //设置大图片的 url
                navbar: false,  //显示缩略图导航
                zoomRatio: 0.4,  //鼠标滚动时的缩放比例
                // minZoomRatio:0.01, //最小缩放比例
                // maxZoomRatio:100, //最大缩放比例
                // zIndex:2015, //设置图片查看器 modal 模式时的 z-index
                button: true,  //显示右上角关闭按钮（jQuery 版本无效）
                title: true,  //显示当前图片的标题（现实 alt 属性及图片尺寸）
                keyboard: true,  //是否支持键盘
                movable: true,  //图片是否可移动
                tooltip: true,  //显示缩放百分比
                // rotatable: true,  //图片是否可旋转
                // scalable: true,  //图片是否可翻转
                toolbar: {   //显示工具栏
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: 1,
                    reset: 1,
                    prev: 0,
                    play: 0,
                    next: 0,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
                viewed: function () {
                    _this[FileGuid].view(0);
                }
            });
            }

            _this[FileGuid].show();

        },
        CommitRequest(formData){
            var _this = this;
            _this.$api.CommitRequest(formData).then(res=>{
                if(res.data.result){
                    this.$message({
                        message: "提交成功",
                        type: 'success',
                        duration: 5 * 1000
                    })
                    this.$router.push("applyRecord");
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                // console.log(res)
            })
        },
        backViewPageFn(){//取消事件
            this.$router.push({
                name: 'viewRecord',
                params: {
                    id: this.paramsData.requestID,
                    pageType: 1,
                    type: this.commitType
                }
            })
        },
        getBigImg(){
            console.log(1111)
            this.ifSmallImg=true;
        },
        submitInfo(dataInfo){
            var _this = this;
            _this.$refs[dataInfo].validate(valid => {
                if(valid){
                    _this.regLoading = true
                    _this.formData.CommitType = this.commitType
                    _this.formData.RequestID = _this.paramsData.requestID
                    _this.formData.RequesterName = _this.dataInfo.RequesterName.NodeValue
                    _this.formData.RequesterPhoneNum = _this.dataInfo.RequesterPhoneNum.NodeValue
                    _this.formData.RequesterOrganisation = _this.dataInfo.RequesterOrganisation.NodeValue
                    _this.formData.PersonIdentification = _this.dataInfo.PersonIdentification.NodeValue
                    _this.formData.ArticleName = _this.dataInfo.ArticleName.NodeValue
                    //
                    _this.formData.Author = _this.dataInfo.Author.NodeValue
                    _this.formData.Publication = _this.dataInfo.Publication.NodeValue
                    _this.formData.PublishTime = _this.dataInfo.PublishTime.NodeValue
                    _this.formData.UnitIdentification = _this.dataInfo.UnitIdentification.NodeValue
                    _this.formData.CheckReport = _this.dataInfo.CheckReport.NodeValue
                    _this.formData.ArticleLocation = _this.dataInfo.ArticleLocation.NodeValue
                    _this.CommitRequest(_this.formData);
                }else{
                    this.$message({
                        message: "您存在未填写信息，请填写完整后再提交",
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })


        },
        CommitRequest(formData){
            var _this = this;
            _this.$api.AgainCommitRequest(formData).then(res=>{
                if(res.data.result){
                    this.$message({
                        message: "提交成功",
                        type: 'success',
                        duration: 5 * 1000
                    })
                    this.$router.push('/applyRecord');
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                // console.log(res) 
            })
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleChange(){

        },
        uploadAuth(single) {
            // 打开文件选择框
            console.log("BUs=====",Bus);
            this.updataType=single
            if(single==0){
                this.dataInfo.PersonIdentification.NodeValue=[]
            }
            //debugger
            Bus.$emit('openuploader', {
                // id: '1111' , // 传入的参数
                loginToken: sessionStorage.getItem("Token"),
                //ifAuth:true
                single:single,
            })

        },
        // 获取详情数据
        detailGetBysearchParam(request){
            var _this = this;
            _this.$api.detailGetBysearchParam(request).then(res => {
                if(res.data.result){
                    var dataList=res.data.info;
                    for(var key in dataList){
                        if(dataList[key] && Array.isArray(dataList[key].NodeValue)){
                            if(dataList[key].CheckStatus==0){
                                dataList[key].NodeValue=[];
                            }
                        }
                        if(dataList[key]&&typeof(dataList[key])=="object"){
                        //    console.log("dataList[key]",dataList[key])
                           if(dataList[key].CheckStatus==0){
                                dataList[key].disabled=false;
                           }else{
                               dataList[key].disabled=true;
                           }

                        }
                    }
                    _this.dataInfo = dataList;
                    // console.log('重新提交_this.dataInfo', _this.dataInfo)

                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })
        }
    },
    destroyed(){
        Bus.$off('filesuccess');
    }
}
</script>
<style>
.input_fileName.is-disabled .el-input__inner{
    /* background: #fff; */
    /* color:#303133; */
}
.input_fileName {
    line-height: 20px!important;
}
.input_fileName .el-input__inner{
    border:none!important;
    height:20px!important;
}
.myForm  input.el-input__inner{
    height:33px;
}
.el-tabs__content{
    background: #F0F2F5!important;
}
</style>
<style lang="scss" scoped>
.main_apply{
    // width:1300px;
}
.main_container{
    width:1100px;
}

.item_box{
    background: #fff;
    padding: 20px;
    margin-bottom: 10px;
    // border-radius: 10px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border-radius: 10px;
}
.title_sty{
    font-size: 16px;
    // width: 1300px;
    color:#606266;
    border-bottom:1px solid #DCDFE6;
    margin-bottom: 10px;
    padding-bottom: 10px;

}
.inpItem{
    height:33px;
}
.el-form-item{
    margin-bottom: 14px;
}
.el-upload__tip{
    font-size: 12px;
    color: red;
    margin-top: 0px;
    height: 20px;
    line-height: 20px;
}
.subBtn_box{
    // padding-left:300px;
    // width:180px;
    // margin:auto;
    margin-left:0px;
    padding-left:120px;
}
.input_box{
    line-height: 20px;
}
.input_box .el-input,.input_box .el-input__inner{
    height: 20px;
    line-height: 20px;
    border:none;
}
.model_span{
    color:#409EFF;
    cursor: pointer;
}
.warn_icon{
    margin-right:5px;
    vertical-align: middle;
 }
 .inpitem_box{
     position: relative;
     .warn_icon{
         position:absolute;
         top:10px;
     }
 }
</style>



// WEBPACK FOOTER //
// reApplyPage.vue?82c16f62